// Per-route metadata used by the root layout.
//
// `shell: 'none'` opts a route out of the AppShell + AppHeader chrome
// — used by S12 sign-in today and reserved for S5 Signal Analysis
// fullscreen mode (Phase 4 (3..N)).
//
// Routes opt in by `staticData: ROUTE_META.fullscreen` in their
// createFileRoute config. The root layout reads it via useMatches()
// (each match exposes its route's staticData) and skips the shell
// when any match in the active chain has shell === 'none'.

export type RouteShell = 'default' | 'none';

export type RouteMeta = {
  shell: RouteShell;
};

export const ROUTE_META = {
  fullscreen: { shell: 'none' } as const satisfies RouteMeta,
  default: { shell: 'default' } as const satisfies RouteMeta,
} as const;
